// extracted by mini-css-extract-plugin
export default {"HomeLink":"style_HomeLink__L4+Ev","secondary":"style_secondary__7jlDl","info":"style_info__Y1DEN"};